var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-header"},[_c('span',[_vm._v("Customize")]),_c('Button',{staticClass:"edit-design"},[(_vm.settings_collapsed)?_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-chevron-down"}}):_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-chevron-up"}})],1),_c('Flash',{ref:"show"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }